import React, { useState } from "react";
import { collection, doc, setDoc } from "firebase/firestore";
// import { useHistory } from 'react-router';
import { auth } from "./firebaseConfig";
import { signOut } from "firebase/auth";
import { Link } from "react-router-dom";

import { database, StorageFolder } from "./firebaseConfig";
import {
  Box,
  Button,
  Center,
  ChakraProvider,
  VStack,
  Stack,
  Image,
  useMediaQuery,
} from "@chakra-ui/react";
import { useLanguage } from "./languageContext";
import LanguageSwitch from "./LanguageSwitch";
import NavBar from "./NavBar";
import Logo from "./Logo";
import DashboardMenu from "./DashboardMenu";
// import { useAuthContext } from './authContext';

const Dashboard1 = () => {
  const [isSmallScreen] = useMediaQuery("(max-width: 1100px)");
  const { language, toggleLanguage } = useLanguage();
  return (
    <ChakraProvider>
      <Box
        backgroundImage={"url(bird.jpeg)"}
        backgroundSize="cover"
        // backdropFilter="auto"
        // backdropBlur={"5px"}
      >
        <NavBar />
        <VStack spacing={4} align="stretch">
          <Stack align="center" width={{ base: "100%" }}>
            <Box
              p={4}
              pt={20}
              width={{ base: "100%", md: "100%" }}
              maxW="1500px"
              minH="100vh"
              minW={{ base: "300px", md: "700px", lg: "880px" }}
            >
              <Box p={8} bg="white" rounded="md" shadow="md" width="100%">
                <DashboardMenu isSmallScreen={isSmallScreen} />
                <Stack
                  direction={{ base: "column", md: "row" }}
                  spacing={4}
                  align={{ base: "center", md: "flex-start" }}
                  justify={{ base: "flex-end", md: "flex-end" }} // Align to the right on smaller screens
                ></Stack>
                <Stack
                  direction={{ base: "column", md: "row" }}
                  spacing={4}
                  align="center"
                  justify={{ base: "flex-end", md: "space-between" }}
                >
                  {/* Logos */}
                  <Logo isSmallScreen={isSmallScreen} />
                </Stack>
                <Center bg="#f8f8f8"></Center>

                <Box textAlign="center" overflowX="auto">
                  <Center>
                    <iframe
                      src="https://public.tableau.com/views/JungleKeepers_17206483853440/JungleKeepersStoryboard?::showVizHome=no&:embed=true&language=en-US&:sid=&:redirect=auth&:display_count=n&:origin=viz_share_link"
                      width="1080"
                      height="955"
                    ></iframe>
                  </Center>
                </Box>
              </Box>
            </Box>
          </Stack>
        </VStack>
      </Box>
    </ChakraProvider>
  );
};

export default Dashboard1;
